// src/components/Header.js
import React from "react";
import { Camera, Instagram, Github, Moon, Sun } from "lucide-react";

export default function Header({ dark, setDark, scrollToId, isFullscreen }) {
    return (
        <header
            className={`fixed top-4 left-1/2 -translate-x-1/2 z-50 
    backdrop-blur supports-[backdrop-filter]:bg-white/30 
    dark:supports-[backdrop-filter]:bg-black/20 
    ${isFullscreen ? "opacity-0 pointer-events-none" : "opacity-100"} 
    transition-opacity duration-300
    rounded-full shadow-lg`}
        >
            <div className="px-6 sm:px-8 lg:px-10 h-14 flex items-center justify-between gap-6">
                {/* Logo / Title */}
                <button
                    onClick={() => scrollToId("hero")}
                    className="flex items-center gap-2 font-semibold tracking-wide"
                >
                    <Camera className="w-5 h-5" />
                    <span>ZeusYohaan</span>
                </button>

                {/* Navigation */}
                <nav className="hidden md:flex items-center gap-6 text-sm">
                    <button onClick={() => scrollToId("portfolio")} className="hover:opacity-80">
                        Portfolio
                    </button>
                    <button onClick={() => scrollToId("contact")} className="hover:opacity-80">
                        Contact
                    </button>
                    <a
                        href="https://www.instagram.com/zeusyohaan/"
                        target="_blank"
                        className="opacity-80 hover:opacity-100"
                        rel="noreferrer"
                        aria-label="Instagram"
                    >
                        <Instagram className="w-5 h-5" />
                    </a>
                    <a
                        href="https://github.com"
                        target="_blank"
                        className="opacity-80 hover:opacity-100"
                        rel="noreferrer"
                        aria-label="GitHub"
                    >
                        <Github className="w-5 h-5" />
                    </a>
                </nav>

                {/* Dark Mode Toggle */}
                <div className="flex items-center">
                    <button
                        onClick={() => setDark((d) => !d)}
                        className="rounded-full px-3 py-1.5 text-xs border border-neutral-300/60
          dark:border-neutral-700/70 hover:bg-neutral-100 dark:hover:bg-neutral-900
          flex items-center gap-2"
                        aria-label="Toggle dark mode"
                    >
                        {dark ? <Moon className="w-4 h-4" /> : <Sun className="w-4 h-4" />}
                        {dark ? "Dark" : "Light"}
                    </button>
                </div>
            </div>
        </header>
    );
}
